import {
  Avatar,
  Button,
  Col,
  Image,
  message,
  Modal,
  Row,
  Space,
  Table,
  Tag,
  Tooltip,
} from 'antd'
import { UserOutlined } from '@ant-design/icons'
import './groupTable.css'
// import ResetPassword from '../resetPassword/resetPassword'
// import EditorMember from '../editorMember/editorMember'
// import DeleteModal from '../deleteModal/deleteModal'
import { forwardRef } from 'react'
import { useState } from 'react'
import { useImperativeHandle } from 'react'
import moment from 'moment/moment'
import { changeGroup, deleteGroup } from '../../../../api/api'
import GroupPriority from '../groupPriority/groupPriority'
import EditGroup from '../editGroup/editGroup'

const Grouptable = forwardRef((props, ref) => {
  const [data, setData] = useState([])
  const { setIsFresh } = props

  const switchIsShow = (num) => {
    switch (num) {
      case 0:
        return '  隐藏'
        break
      case 1:
        return '显示'
        break
      default:
        break
    }
  }

  const handleHide = (record) => {
    const params = {
      id: record.id,
      is_visible: record.is_visible ? 0 : 1,
    }
    changeGroup(params)
      .then((res) => {
        console.log(res)
        message.success('修改展示状态成功')
        setIsFresh((pre) => !pre)
      })
      .catch((err) => {
        console.log(err)
        message.err('修改展示状态失败')
      })
  }

  //删除数据的回调
  const deleteSecondHand = (id) => {
    Modal.confirm({
      title: '请确认',
      //  icon: <ExclamationCircleOutlined />,
      content: '您确定要删除此内容吗？删除后不可恢复。',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        deleteGroup(id)
          .then((res) => {
            const newData = data.filter((item) => item.id !== id)
            setData(newData)
            message.success('删除内容成功！')
          })
          .catch((err) => console.log(err))
      },
    })
  }

  const columns = [
    {
      title: '编号',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },
    {
      title: '群聊名称',
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: '状态',
      dataIndex: 'is_visible',
      key: 'is_visible',
      width: 100,
      render: (is_visible) => {
        return <>{switchIsShow(is_visible)}</>
      },
    },
    {
      title: '优先级',
      key: 'priority',
      dataIndex: 'priority',
    },
    {
      title: '群聊图片',
      dataIndex: 'group_image',
      key: 'group_image',
      width: 300,
      render: (image) => {
        return (
          <>
            <Image style={{ padding: 5 }} src={image} width={300} height={60} />
          </>
        )
      },
    },
    {
      title: '发布时间',
      key: 'createdAt',
      dataIndex: 'createdAt',
    },

    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: '20%',
      render: (_, record) => (
        <Space size="middle">
          <EditGroup
            groupDetail={record}
            // total={total}
            setIsFresh={setIsFresh}
          />{' '}
          <a onClick={() => deleteSecondHand(record.id)}>删除</a>
          <GroupPriority
            id={record.id}
            value={record.priority}
            setIsFresh={setIsFresh}
            name="is_prioritized"
          />
          <a onClick={() => handleHide(record)}>
            {record.is_visible ? '隐藏' : '显示'}
          </a>
        </Space>
      ),
    },
  ]

  const switchRole = (num) => {
    const res = []
    num.map((item, index) => {
      switch (item) {
        case 1:
          res.push('超级管理员')
          break
        case 2:
          res.push('管理员')
          break
        case 3:
          res.push('审核员')
          break
        case 4:
          res.push('房源管理员')
          break
        case 5:
          res.push('内容管理员')
          break
        case 6:
          res.push('活动管理员')
          break
        default:
          break
      }
    })
    const finalres = res.join('、')
    // console.log(finalres);
    return finalres
  }
  const changeData = (data) => {
    data.map((info, index) => {
      info.key = index
      // const date = new Date(info.created_at)
      info.createdAt = moment(info.created_at).format('YYYY-MM-DD HH:mm:ss')
      // console.log(info.created_at,info.createdAt)
      return info
    })

    setData(data)
  }

  useImperativeHandle(ref, () => ({
    changeData,
  }))

  return (
    <div
      className="grouptTable"
      style={{ backgroundColor: 'white', padding: '30px' }}
    >
      {/* <Row>
        <Col flex={4}></Col>
        <Col flex={1}>

        </Col>
      </Row> */}
      <Table columns={columns} dataSource={data} pagination={false} />
    </div>
  )
})

export default Grouptable
